const ChucnangStyle = () => ({
  card_body_slst: {
    width: "95%",
    height: "450px",
    "@global": {
      "*::-webkit-scrollbar": {
        width: "0.7em",
        height: "0.8em",
      },
      "*::-webkit-scrollbar-track": {
        "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.2)",
        outline: "1px solid slategrey",
      },
    },
  },
  table: {
    width: "100%",
    height: "96%",
    fontSize: "0.85vw",
    overflowY: "auto",
    overflowX: "hidden",
  },
  tabledb: {
    textAlign: "center",
    width: "98%",
    marginLeft: "5px",
    marginRight: "5px",
    fontSize: "0.85vw",
    borderSpacing: "0",
    borderCollapse: "collapse",
    marginTop: "5px",
  },
  tabledb_th: {
    border: "1px solid #4f7edb",
  },
  tabledb_ct_th: {
    border: "1px solid #006457",
  },
  tabledb_td: {
    border: "1px solid #4f7edb",
    color: "#00ec00",
    fontWeight: "700",
    textAlign: "left",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "blue",
    },
  },
  tabledb_td_ptgt: {
    border: "1px solid #4f7edb",
    color: "#ccca00",
    fontWeight: "700",
    textAlign: "left",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "blue",
    },
    paddingLeft: 7,
  },
  tabledb_ct_td: {
    border: "1px solid #003f88",
    color: "#006457",
    fontWeight: "700",
    textAlign: "left",
  },
  tabledb_td_number: {
    border: "1px solid #4f7edb",
    color: "#00ec00",
    fontWeight: "700",
    textAlign: "right",
  },
  tabledb_td_number_ptgt: {
    border: "1px solid #4f7edb",
    color: "#ccca00",
    fontWeight: "700",
    textAlign: "right",
  },
  chuaht_td_number: {
    border: "1px solid #4f7edb",
    color: "red",
    fontWeight: "700",
    textAlign: "center",
  },
  tablechuaht_td_number: {
    border: "1px solid #4f7edb",
    color: "#ec0007",
    fontWeight: "700",
    textAlign: "center",
  },
  tabledb_ct_td_number: {
    border: "1px solid #003f88",
    color: "#006457",
    fontWeight: "700",
    textAlign: "right",
  },
  tabledb_ct_td_click: {
    border: "1px solid #003f88",
    color: "#00ec00",
    fontWeight: "700",
    textAlign: "right",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "blue",
    },
  },
  tabledb_td_cap: {
    border: "1px solid #4f7edb",
    color: "#ff9e00",
    fontWeight: "700",
    textAlign: "left",
  },
  tabledb_td_cap_number: {
    border: "1px solid #4f7edb",
    color: "#ff9e00",
    fontWeight: "700",
    textAlign: "right",
  },
  tooltip: {
    fontWeight: "400",
    textAlign: "center",
    fontSize: "1vw",
    color: "#000000",
  },
});

export default ChucnangStyle;
